/**
 * End User Response Components Styles
 */

import styled from 'styled-components';

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 24px;
  max-width: 600px;
  margin: 0 auto;
`;

export const SuccessIcon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
`;

export const InfoBox = styled.div`
  background: ${({ theme }) => theme.background?.secondary || 'rgba(255, 255, 255, 0.05)'};
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 16px;
  width: 100%;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 32px;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;

    button {
      width: 100%;
    }
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 24px;
  text-align: center;
`;

export const ErrorIcon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
  opacity: 0.7;
`;
